/**
 *
 * Enum for NAVTAB values for synthetic monitoring capability.
 * @readonly
 * @enum {string}
 */
export enum K8_NAVTABS {
  /** @member {string} */
  K8M_CLUSTER_TAB = 'cluster',
  /** @member {string} */
  K8M_NODE_TAB = 'nodes',
  /** @member {string} */
  K8M_DEP_TAB = 'deployments',
  /** @member {string} */
  K8M_STAT_TAB = 'statefulsets',
  /** @member {string} */
  K8M_DAEMON_TAB = 'daemonsets',
  /** @member {string} */
  K8M_POD_TAB = 'pods',
  /** @member {string} */
  K8M_NAMESPACE_TAB = 'namespaces',
}